

export class TyreBrandUpdateInput implements ITyreBrandUpdateInput {
    /** The auto-generated id of the tyre brand master */
    tyreBrandId!: number;
    /** The tyre brand name with 255 character limit */
    tyreBrandName!: string;

    constructor(data?: ITyreBrandUpdateInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tyreBrandId = _data["tyreBrandId"];
            this.tyreBrandName = _data["tyreBrandName"];
        }
    }

    static fromJS(data: any): TyreBrandUpdateInput {
        data = typeof data === 'object' ? data : {};
        let result = new TyreBrandUpdateInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tyreBrandId"] = this.tyreBrandId;
        data["tyreBrandName"] = this.tyreBrandName;
        return data; 
    }
}

export interface ITyreBrandUpdateInput {
    /** The auto-generated id of the tyre brand master */
    tyreBrandId: number;
    /** The tyre brand name with 255 character limit */
    tyreBrandName: string;
}

